/* istanbul ignore file */
import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { DateInput, TextArea, TextInput, ClearAfterUnmountWrapper } from 'framework/form';
import { PURCHASE_ORDER_TYPES } from '../usePurchaseOrderService';
import { EmployeeInput, OfficeCodeDropdown } from 'domain/shared/employee';
import { useDateService } from 'framework/utils';
import BudgetCategoryDropdownWrapper from 'domain/finance/journalEntry/shared/input/BudgetCategoryDropdownWrapper';
import CurrencyDropdownWithoutEur, {
  DROPDOWN_CURRENCY_TYPES,
} from 'domain/finance/shared/input/CurrencyDropdownWithoutEur';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import PurchaseOrderTypeDropdown from 'domain/finance/purchaseOrder/shared/input/PurchaseOrderTypeDropdown';
import { AccountInput } from 'domain/shared/ledger';
import PurchaseListInput from 'domain/finance/purchaseOrder/shared/input/PurchaseListInput';
import { ExpenseProjectDropdown, isProjectSuggestionAccount } from 'domain/shared/project';

const isProjectSuggestionVisible = (data: any): boolean => isProjectSuggestionAccount(data.account);

const { BYN, ...CURRENCY_TYPES } = DROPDOWN_CURRENCY_TYPES || {};

const PurchaseOrderForm = () => {
  const { searchPurchaseOrderAccount } = useLedgerService();
  const { getCurrentDateTime, formatDateForAPI } = useDateService();
  const now = formatDateForAPI(getCurrentDateTime());

  return (
    <FormSection>
      <FormRow>
        <PurchaseOrderTypeDropdown source="type" label="Type" />
        <TextInput source="title" label="Title" />
        <TextInput source="vendor" label="Vendor" />
        <OfficeCodeDropdown source="office" label="Office" />
      </FormRow>
      <FormRow>
        <AccountInput
          source="account"
          label="Account"
          loadDataMethod={searchPurchaseOrderAccount}
          cacheKey="purchase-order-accounts"
        />
        <CurrencyDropdownWithoutEur source="currency" label="Currency" options={{ ...CURRENCY_TYPES, BYR: 'BYN' }} />
        <ClearAfterUnmountWrapper isVisible={(data: any) => data.type === PURCHASE_ORDER_TYPES.STANDARD}>
          <DateInput source="requiredDeliveryDate" label="Required delivery date" />
        </ClearAfterUnmountWrapper>

        <ClearAfterUnmountWrapper
          isVisible={(data: any) =>
            data.type === PURCHASE_ORDER_TYPES.BLANKET || data.type === PURCHASE_ORDER_TYPES.CONTRACT
          }
        >
          <DateInput source="expirationDate" label="Expiration date" />
        </ClearAfterUnmountWrapper>
        <ClearAfterUnmountWrapper isVisible={(data: any) => data.account}>
          <BudgetCategoryDropdownWrapper dateValue={now} accountIdValue="account" source="budgetCategory" />
        </ClearAfterUnmountWrapper>
      </FormRow>
      <FormRow>
        <ClearAfterUnmountWrapper isVisible={isProjectSuggestionVisible}>
          <ExpenseProjectDropdown source="project.projectId" label="Project" />
        </ClearAfterUnmountWrapper>
        <EmployeeInput source="requestor" nameSource="requestorName" label="Requestor" />
      </FormRow>
      <BigFormRow>
        <TextArea source="purchasePurpose" label="Purchase purpose" />
      </BigFormRow>
      <PurchaseListInput source="purchases" label="Purchases" currencySource="currency" />
    </FormSection>
  );
};

export default PurchaseOrderForm;
